import { render, staticRenderFns } from "./ServiceExpandable.vue?vue&type=template&id=56242fe8"
import script from "./ServiceExpandable.vue?vue&type=script&lang=js"
export * from "./ServiceExpandable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports